export function getContactName(name) {
  let _name = ''
  let string = name.replace(/:/g, "：")
  if(string.indexOf("：")!= -1){
    let arr = string.split('：')
    _name = arr[arr.length-1]
  }
  return _name
}

export function getContactParams(res) {
  let string = res.icon_desc
  let _obj = {}
  if(string != '' && string != null){
    string = string.replace(/:/g, "：")
    if(string.indexOf("：") != -1){
      let arr = string.split('：')
      _obj = {
        contactLabel:arr[0],
        user:{
          id:1,
          name:arr[1],
        }
      }
    }else{
      _obj = {
        contactLabel:'',
        user:{
          id:1,
          name:string,
        }
      }
    }

  }

  return _obj
}

export function setPageConfig(params) {
  document.querySelector('meta[name="keywords"]').setAttribute('content', params.keyword)
  document.querySelector('meta[name="description"]').setAttribute('content', params.description)
  document.title = params.title.toUpperCase();
}
//路由跳转
export function navigateTo(url) {
  if(url != this.$router.history.current.path){
    this.$router.push(url)
  }
}
//获取链接地址
export function getUrlExp(url,record) {
  var str = url
  var reg = /\{(.+?)\}/
  var reg_g = /\{(.+?)\}/g
  var result = str.match(reg_g)
  if(result){
    result.forEach((match,i)=>{
      let key = result[i].match(reg)[1]
      let _value = record[key]
      if(typeof _value == "string"){
        _value = encodeURIComponent(_value)
      }
      str = str.replace(result[i],_value)
    })
  }
  return str
}
